import { Container } from "@bryntum/schedulerpro";

export default class TimelineConfiguratorTabBase extends Container {
  static get $name() {
    return "TimelineConfiguratorTabBase";
  }

  static get type() {
    return "timelineconfiguratortabbase";
  }

  static get configurable() {
    return {
      autoUpdateRecord: true
    };
  }

  editRecord(record, context, otherParams) {
    this.loading = true;
    this.loadRecord(record, context, otherParams);
    this.loading = false;
  }

  loadRecord(record, context) {
    this.record = record;
    this.context = context;
    Object.assign(this, context);
    this.swivuCheckGrants(context.user)
  }

  swivuCheckGrants() {}
}

TimelineConfiguratorTabBase.initClass();
